import { DateTime } from 'luxon';
const YYYY_MM_DD = /^\d{4}-\d{2}-\d{2}$/;
/**
 * Calcula la edad en años cumplidos para una fecha de nacimiento dada, en una fecha de referencia y zona horaria.
 * Si el nacimiento fue un 29 de febrero, en años no bisiestos se considera que el cumpleaños es el 1 de marzo.
 *
 * @param fechaNacimiento Fecha de nacimiento en formato YYYY-MM-DD
 * @param ahora Fecha de referencia
 * @param zona Zona horaria (por defecto America/Asuncion)
 */
export function edadEn(fechaNacimiento, ahora, zona = 'America/Asuncion') {
    if (!fechaNacimiento || !YYYY_MM_DD.test(fechaNacimiento)) {
        return null;
    }
    const dtAhora = DateTime.fromJSDate(ahora, { zone: zona });
    if (!dtAhora.isValid) {
        return null;
    }
    const dtNacimiento = DateTime.fromISO(fechaNacimiento, { zone: zona });
    if (!dtNacimiento.isValid) {
        return null;
    }
    const anioActual = dtAhora.year;
    const mesNacimiento = dtNacimiento.month;
    const diaNacimiento = dtNacimiento.day;
    const esBisiestoActual = DateTime.fromObject({ year: anioActual }, { zone: zona }).isInLeapYear;
    let mesCumple = mesNacimiento;
    let diaCumple = diaNacimiento;
    if (mesNacimiento === 2 && diaNacimiento === 29 && !esBisiestoActual) {
        mesCumple = 3;
        diaCumple = 1;
    }
    const dtCumpleEsteAnio = DateTime.fromObject({
        year: anioActual,
        month: mesCumple,
        day: diaCumple,
    }, { zone: zona });
    let edad = anioActual - dtNacimiento.year;
    if (dtAhora.startOf('day') < dtCumpleEsteAnio.startOf('day')) {
        edad--;
    }
    return Math.max(0, edad);
}
export function esMenorDeEdad(fechaNacimiento, ahora, zona = 'America/Asuncion') {
    if (!fechaNacimiento)
        return false;
    const edad = edadEn(fechaNacimiento, ahora, zona);
    if (edad === null)
        return false;
    return edad < 18;
}
/**
 * Años y meses cumplidos en la fecha civil de `zona`. null si la fecha no es YYYY-MM-DD válida.
 */
export function edadAniosMeses(fechaNacimiento, ahora, zona = 'America/Asuncion') {
    const anios = edadEn(fechaNacimiento, ahora, zona);
    if (anios === null)
        return null;
    const dtAhora = DateTime.fromJSDate(ahora, { zone: zona }).startOf('day');
    const dtNacimiento = DateTime.fromISO(fechaNacimiento, { zone: zona });
    const mesNacimiento = dtNacimiento.month;
    const diaNacimiento = dtNacimiento.day;
    let anioCumple = dtAhora.year;
    let esBisiestoCumple = DateTime.fromObject({ year: anioCumple }, { zone: zona }).isInLeapYear;
    let mesCumple = mesNacimiento;
    let diaCumple = diaNacimiento;
    if (mesNacimiento === 2 && diaNacimiento === 29 && !esBisiestoCumple) {
        mesCumple = 3;
        diaCumple = 1;
    }
    const dtCumpleEsteAnio = DateTime.fromObject({
        year: anioCumple,
        month: mesCumple,
        day: diaCumple,
    }, { zone: zona }).startOf('day');
    let dtCumplePasado = dtCumpleEsteAnio;
    if (dtAhora < dtCumpleEsteAnio) {
        anioCumple--;
        esBisiestoCumple = DateTime.fromObject({ year: anioCumple }, { zone: zona }).isInLeapYear;
        mesCumple = mesNacimiento;
        diaCumple = diaNacimiento;
        if (mesNacimiento === 2 && diaNacimiento === 29 && !esBisiestoCumple) {
            mesCumple = 3;
            diaCumple = 1;
        }
        dtCumplePasado = DateTime.fromObject({
            year: anioCumple,
            month: mesCumple,
            day: diaCumple,
        }, { zone: zona }).startOf('day');
    }
    const diff = dtAhora.diff(dtCumplePasado, ['months']).toObject();
    // Desde el último cumpleaños nunca pasan 12 meses. Luxon puede contar 12 entre
    // un 29/02 y el 28/02 siguiente (ajusta al fin de febrero), cuando el cumpleaños
    // recién se cumple el 1/03 (ver `edadEn`).
    const meses = Math.min(11, Math.max(0, Math.floor(diff.months || 0)));
    return { anios, meses };
}
//# sourceMappingURL=edad.js.map